import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import LoginEmailForm from './LoginEmailForm';
import LoginPasswordForm from './LoginPasswordForm';
import LoginSocial from './LoginSocial';
import LoginJoinMoncler from './LoginJoinMoncler';
import RegisterForm from './RegisterForm';
import ClothingRegisterForm from './ClothingRegisterForm';
import { useTranslation } from 'react-i18next';
import DoubleOptInForm from './DoubleOptInForm';
import LoginOrRegisterSocial from './LoginOrRegisterSocial';
import OtherLoginMethods from './OtherLoginMethods';
import RegisteredInStore from './RegisteredInStore';
import RegisteredInStoreSendEmail from './RegisteredInStoreSendEmail';
import WalletConnectBtn from '@moncler/components/nft/WalletConnectBtn';
const LoginOrRegisterPage = (props) => {
    const { t } = useTranslation();
    const [loginStep, setLoginStep] = useState('email');
    const [loginEmail, setLoginEmail] = useState();
    // available login methods sorted by last accessed
    const [loginMethods, setLoginMethods] = useState([]);
    const [doubleOptIn, setDoubleOptIn] = useState(false);
    const [fromRegister, setFromRegister] = useState(false);
    useEffect(() => {
        if (window.clothingEmail) {
            setLoginStep('password');
            setDoubleOptIn(true);
            setLoginEmail(window.clothingEmail);
        }
        if (window.customerData && window.customerEmail) {
            setLoginEmail(window.customerEmail);
            setLoginStep('register');
        }
    }, []);
    useEffect(() => {
        // force scroll top on change step
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }, [loginStep]);
    return (React.createElement("div", { className: "row justify-center login-registration" },
        loginStep == 'email' && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classNames('col-lg-4 col-md-5 col-sm-8', { 'col-md-6 col-sm-8': window.isClothing }) },
                React.createElement("div", { className: "login-registration__login" },
                    React.createElement(LoginEmailForm, { setLoginStep: setLoginStep, setLoginEmail: setLoginEmail, setLoginMethods: setLoginMethods, setDoubleOptIn: setDoubleOptIn, isLoginOrRegisterPage: true, profileForm: props.profileform })),
                !window.isClothing && window.sociallogin && window.enabledSocials.length > 0 && (React.createElement("div", { className: "login-registration__social" },
                    React.createElement("p", { className: "mb-24" }, t('login.signinsocial')),
                    React.createElement(LoginOrRegisterSocial, { secondary: true }))),
                !window.isClothing && window.wconnectUrl && (React.createElement("div", { className: "login-registration__wallet-connect" },
                    React.createElement("p", { className: "mb-24" }, t('login.signinwalletconnect')),
                    React.createElement(WalletConnectBtn, { btnClass: "primary-s wallet-connect-btn", icon: true, analyticsCategory: "my moncler", analyticsAction: "wallet connect" })))),
            !window.isClothing && (React.createElement("div", { className: "col-md-4 col-sm-8 offset-lg-0 offset-md-1" },
                React.createElement(LoginJoinMoncler, { inModal: true }))))),
        loginStep == 'password' && (React.createElement("div", { className: "col-md-6 col-sm-8" },
            React.createElement(LoginPasswordForm, { setLoginStep: setLoginStep, loginEmail: loginEmail, rememberme: props.rememberme, privacypolicy: props.privacypolicy, forgotpasswordform: props.forgotpasswordform, doubleOptIn: doubleOptIn }))),
        loginStep == 'social-login' && (React.createElement("div", { className: "col-lg-4 col-md-6 col-sm-8" },
            React.createElement(LoginSocial, { setLoginStep: setLoginStep, loginEmail: loginEmail, socialUsed: loginMethods[0].ID }))),
        !window.isClothing && ((loginStep == 'password' && loginMethods.length > 1) || loginStep == 'social-login') && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "col-12" },
                React.createElement("div", { className: "row justify-center" },
                    React.createElement("div", { className: classNames('col-sm-8 col-md-6 mt-32 border-top pt-32', { 'col-lg-4': loginStep == 'social-login' }) }))),
            React.createElement("div", { className: "col-12" },
                React.createElement("div", { className: "row justify-center" },
                    React.createElement("div", { className: "col-sm-8 col-md-6 col-lg-4" },
                        React.createElement(OtherLoginMethods, { loginMethods: loginMethods, setLoginStep: setLoginStep, loginStep: loginStep })))))),
        loginStep == 'register' && (React.createElement("div", { className: "col-md-6 col-sm-8" },
            React.createElement("div", { className: "login-registration__registration" }, window.isClothing ? (React.createElement(ClothingRegisterForm, { conditionsofuse: props.conditionsofuse, privacypolicy: props.privacypolicy, doubleOptIn: doubleOptIn, loginEmail: loginEmail, setLoginStep: setLoginStep, setFromRegister: setFromRegister })) : (React.createElement(RegisterForm, { loginEmail: loginEmail, setLoginStep: setLoginStep, fromPage: true, onBack: () => {
                    if (!window.isClothing && loginMethods.length > 0) {
                        setLoginStep('social-login');
                    }
                    else {
                        setLoginStep('email');
                    }
                } }))))),
        loginStep == 'doubleOptIn' && window.isClothing && (React.createElement("div", { className: "col-md-6 col-sm-8" },
            React.createElement("div", { className: "login-registration__registration" },
                React.createElement(DoubleOptInForm, { fromRegister: fromRegister, doubleOptIn: doubleOptIn, loginEmail: loginEmail, setLoginStep: setLoginStep })))),
        loginStep == 'registeredInStore' && (React.createElement("div", { className: "col-md-6 col-sm-8" },
            React.createElement("div", { className: "login-registration__registration registered-in-store" },
                React.createElement(RegisteredInStore, { rememberme: true, loginEmail: loginEmail, setLoginStep: setLoginStep })))),
        loginStep == 'registeredInStoreSendEmail' && (React.createElement("div", { className: "col-md-4" },
            React.createElement("div", { className: "login-registration__registration registered-in-store-send-email" },
                React.createElement(RegisteredInStoreSendEmail, { loginEmail: loginEmail, setLoginStep: setLoginStep }))))));
};
export default LoginOrRegisterPage;
